<div>
  <div class="d-flex justify-content-between mb-3">
    <img
      src="assets/icons/calendar-arrow-left.svg"
      role="button"
      [(viewDate)]="viewDate"
      [view]="CalendarView.Month"
      mwlCalendarPreviousView
    />

    <span class="my-calendar-events__title">
      {{ viewDate | calendarDate: "monthViewTitle":"en" }}
    </span>

    <img
      src="assets/icons/calendar-arrow-right.svg"
      role="button"
      [(viewDate)]="viewDate"
      [view]="CalendarView.Month"
      mwlCalendarNextView
    />
  </div>
  <div class="my-calendar-events__today-row mb-3">
    <span class="my-calendar-events__title">{{ viewDateFormatted }}</span>

    <app-button (click)="selectToday()" buttonStyle="white-outlined" buttonSize="extra-small">Today</app-button>
  </div>
  <mwl-calendar-month-view
    [viewDate]="viewDate"
    [events]="myEvents"
    [activeDayIsOpen]="activeDayIsOpen(viewDate)"
    (dayClicked)="handleDayClicked($event.day)"
    weekStartsOn="1"
    (beforeViewRender)="beforeMonthViewRender($event)"
  ></mwl-calendar-month-view>
</div>
